module.exports = __webpack_public_path__ + "img/file-pdf-solid.4d0b262c.svg";